<template>
  <CCol>
    <CRow :gutters="false" class="pt-3 mb-4" v-if="channel == 'sms'">
      <CCol sm="12" md="4">
        <transition name="fade">
          <SelectCountry label data-cy="selectCountryTablerecurrentAddOns" :countrySelected="countrySelected" @add-country="setCountry" />
        </transition>
      </CCol>
      <CCol class="d-flex justify-content-end">
        <div class="ml-5 text-gray-700">
          <div class="d-block mb-2 font-weight-bold text-gray-base">{{ $t('balance.components.balaceTabPacks.country.current-balance') }}</div>
          <div class="text-uppercase h3 text-gray-base text-right">
            {{ countryCurrentBalance | numberWithCommas }}
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <div class="emptyList d-flex flex-column justify-content-center align-items-center bg-gray-200 p-4" v-if="loading">
          <CSpinner class="my-3" color="primary" />
        </div>
        <ul class="px-0 py-4 packList" v-else>
          <li v-for="(pack, index) in packs" :key="index" class="bg-white packList__item py-5 px-4 position-relative rounded-lg">
            <span v-if="index == 2" class="flag-bestSeller">
              {{ $t('balance.components.balaceTabPacks.bestSeller') }}
            </span>

            <h4 class="font-weight-bold text-gray-base h4 mb-4">
              {{ pack.balance | numberWithCommas }} {{ $t(`balance.components.balaceTabPacks.channel.${channel}`) }}
            </h4>
            <!-- <span class="font-md text-uppercase d-block mb-4">{{ nameTypePack(channel) }}</span> -->

            <template v-for="value in pack.types">
              <CRow form class="justify-content-between text-gray-600" :key="`${pack.balance}--${value.id}`" v-if="show">
                <CCol>
                  <div class="mb-0 w-100" v-if="showAddOnRecurrenceType(value.addOnRecurrenceType)">
                    <p class="d-flex text-gray-base font-weight-bold font-5xl">{{ value.price }} €</p>
                    <CButton
                      class="w-100 text-uppercase py-3 font-weight-bold rounded-lg mt-5 btn-primary"
                      @click="selectedPack(pack.name, value, pack.types, pack.balance)"
                    >       
                    <template v-if="clickedPackId == value.id">
                      <div v-show="isToShowBtnText">{{ $t('balance.components.balaceTabPacks.buttom.buy') }}</div>
                      <div v-show="isLoading" class="loadingBtn"></div>
                      <div v-show="isAdded"><CIcon class="check mr-2" name="checkMark" :height="50" viewBox="0 0 32 32" /></div>
                    </template>
                    <div v-else>{{ $t('balance.components.balaceTabPacks.buttom.buy') }}</div>
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </template>
          </li>
        </ul>
      </CCol>
    </CRow>
  </CCol>
</template>

<script>
import { nameCountries } from '@/utils/countriesUtils.js'
import { enumChannelType } from '@/utils/enumsUtils.js'
import SelectCountry from './SelectCountry.vue'

export default {
  name: 'BalanceTabPacks',
  components: {
    SelectCountry,
  },
  props: {
    addOnRecurrenceType: {
      type: Number,
      default: () => 1,
    },
    channel: {
      type: String,
      default: () => 'email',
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    countrySelected: {
      type: String,
      default: () => 'ROW',
    },
    countryPack: {
      type: Array,
      default: () => [],
      require,
    },
    packs: {
      type: Array,
      default: () => [],
      require,
    },
    countryCurrentBalance: {
      type: Number,
      default: () => 0,
      require,
    },
  },

  data() {
    return {
      selected: [],
      show: true,
      isLoading: false,
      isAdded: false,
      isToShowBtnText: true,
      clickedPackId: null,
      cartPackges: this.$store.state.balance.steps.cartPackges
    }
  },

  methods: {
    showAddOnRecurrenceType(type) {
      return this.addOnRecurrenceType == type
    },

    getFlag(data) {
      if (!data) {
        return []
      }
      const item = nameCountries(this).filter((item) => item.value.toUpperCase() == data.toUpperCase())
      if (item[0]) {
        return { ...item[0] }
      }
      return ''
    },

    nameTypePack(type) {
      return enumChannelType(type)
    },

    setCountry(country) {
      this.$emit('setCountry', country)
    },

    isActive(indexPack, valueId) {
      return this.selected.find((item) => item.valueId == valueId && item.indexPack == indexPack) ? true : false
    },

    isBuyActive(indexPack) {
      return this.selected.find((item) => item.indexPack == indexPack) ? true : false
    },

    toogleId(indexPack, valueId) {
      const INDEX = this.selected.findIndex((item) => item.indexPack == indexPack)
      if (INDEX >= 0) {
        this.selected[INDEX].valueId = valueId
        return
      }

      this.selected.push({ indexPack, valueId })
    },

    selectedPack(packName, packSelected, packsTypes, quantityPackage) {
      this.clickedPackId = packSelected.id
      this.isToShowBtnText = false
      this.isLoading = true //"quantity": 1
      
      var hasItem = this.cartPackges.filter((item) => item.package.packSelected.id == packSelected.id) 

      var cartNewItem = { 
        "package": { packSelected, packsTypes }, 
        "channel": this.channel, 
        "quantityPackage": quantityPackage, 
        "packName": packName,
        "quantity": 0,
        "country": this.$store.state.balance.steps.selectedCountry
        }
      
      if(hasItem.length == 0){
        cartNewItem.quantity = 1
      } else if(hasItem.length > 0){
        cartNewItem.quantity = hasItem.length + 1
      }
      setTimeout(() => {
        this.isLoading = false
        this.isAdded = true
        setTimeout(() => {
          this.isAdded = false 
          this.isToShowBtnText = true
          this.clickedPackId = null
          this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'lastSelectedPackName', data: packName })
          this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'showCartNotification', data: true })
          this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'package', data: { packSelected, packsTypes } })
          this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'channel', data: this.channel })
          this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'quantityPackage', data: quantityPackage })
          this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'cartPackges', data: cartNewItem })
          window.scrollTo({ top: 0, behavior: 'smooth' });
          //this.$store.dispatch('balance/steps/setCurrentStep', 2)
          setTimeout(() => {this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'showCartNotification', data: false })}, 5000)
        }, 2000)
      }, 3000);

    },
  },

  watch: {
    addOnRecurrenceType() {
      this.selected = []
    },
    channel() {
      this.selected = []
    },
    countrySelected() {
      this.selected = []
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
  margin-top: 0.5rem !important;
}

.radioPack {
  visibility: hidden;
  padding: 0 !important;
  width: 0;
  height: 0;
}

label {
  border: 2px solid transparent;
}

.flag-bestSeller {
  position: absolute;
  top: -1px;
  right: 0;
  background: var(--primary);
  padding: 0.5rem 0.7rem;
  font-weight: bold;
  text-transform: uppercase;
  color: var(--white);
  border-top-right-radius: 13%;
  border-bottom-left-radius: 15px 15px;
}

.packList {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 15px;
  grid-row-gap: 15px;

  @media only screen and (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(1, 1fr);
    grid-column-gap: 35px;
    grid-row-gap: 35px;
  }

  &__item {
    border: 2px solid var(--gray-200);

    &:hover {
      border: 2px solid var(--primary);
      box-shadow: 0px 5px 12px 0 rgba(34, 37, 43, 0.14);
    }

    &:nth-child(3) {
      border: 3px solid var(--primary);
      box-shadow: 0px 5px 12px 0 rgba(34, 37, 43, 0.14);
    }
  }
}

.loadingBtn {
  background: url(/img/loading.gif);
  background-size: 24px 24px;
  background-position: center;
  background-repeat: no-repeat;
  height: 24px;
  width: 24px;
  margin-left: 44%;
}

.check {
  color: #fff;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
